import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { RoomPlayerAction } from "@uno/protocol";
import useStoreRoomPlayer from "store/useStoreRoomPlayer";
import getPublicAssetUrl from "utils/PublicAsset";

const SWAP_TARGET_ICON = getPublicAssetUrl("assets/rules/swap-target.webp");

const DiscardSwapPrompt = () => {
    const { t } = useTranslation();
    const isChoosing = useStoreRoomPlayer(state => state.roomPlayer?.action === RoomPlayerAction.ChoosingSwapTarget);

    if(!isChoosing) {
        return null;
    }

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1.15 }}
            transition={{ duration: 0.25 }}
            className="absolute z-[25] w-full h-full rounded-full border-4 bg-white flex flex-col items-center justify-center gap-1 px-3 text-center"
            style={{ borderColor: "rgba(100, 100, 100, 1)" }}
        >
            <img src={SWAP_TARGET_ICON} alt="" width={44} height={44} className="w-11 h-11" />
            <span className="font-changa-one text-sm leading-tight text-gray-800 text-balance">{t("room.swap.choose")}</span>
        </motion.div>
    );
};

export default DiscardSwapPrompt;
